export function hero() {
  const hero = document.querySelector('#home-hero');
  if(hero){
    const heroImage = hero.getElementsByClassName('hero-image');
    const heroImageFirst = heroImage[0];
    const transition = 10000;
    let eq = 1;
    let heroImagePast = null;
    const length = heroImage.length - 1;

    heroImageFirst.classList.add('active', 'show');

    setInterval( () => {
      for (let i = 0; i < heroImage.length; i++) {
        const el = heroImage[i];
        el.classList.remove('show');
      }

      const heroImageCurrent = heroImage[eq];
      heroImageCurrent.classList.add('active', 'show');

      setTimeout( () => {
        if(heroImagePast) {
          heroImagePast.classList.remove('active');
        } else {
          heroImageFirst.classList.remove('active');
        }
      }, 3100);

      if (eq == length) {
        eq = 0;
      } else {
        eq++;
      }
      
      setTimeout( () => {
        heroImagePast = heroImageCurrent;
      }, transition);

    }, transition);
  }
}